(ns common.schema.entities.person
  (:require
   [common.gender :as gender]
   [common.schema.option-filters :as option-filters]
   [common.schema.constraints :as constraints]
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common-schema]
   [common.schema.entities.customer :as customer]
   [common.country :as country]))

(def import-fixed-fields
  [:common/external-id :person/first-name :person/last-name :person/universal-email-address])

(def schema
  (vec
   (concat
    customer/schema
    [common-schema/common-network-drive-field]
    common-schema/common-network-drives-field
    common-schema/common-folders-path
    (su/single-ref-field :person/company
                         "Company"
                         [:entity.type/company]
                         {:default-field-visibility :not-in-use-blocked})
    [[:person/name
      {:field/data-type             :data.type/text-simple
       :field/name-attribute        :person/name
       :field/default-visibility    {:editor :editor.type/none
                                     :grid   :editor.type/text-simple
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/system}
       :field/system-semantics      su/system-controlled-optional-field-semantics
       :field/translations          {:en "Name"}
       :field/not-importable?       true
       :field/composite-attributes  [:person/first-name :person/last-name]
       :field/calculated-field      (fn [{:keys [display-string entity-data]}]
                                      (display-string entity-data))}]
     [:person/first-name
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "First name"}}]
     [:person/last-name
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Last name"}}]
     [:person/universal-email-address
      {:field/data-type             :data.type/text-simple
       :field/mandatory             :mandatory/always
       :field/default-visibility    {:editor :editor.type/text-simple
                                     :grid   :editor.type/text-simple
                                     :filter :filter.type/text
                                     :field-visibility :in-use-disabled}
       :field/lower-case-str?       true
       :field/constraints           {:constraint/string-min-length 1
                                     :constraint/valid-email       true
                                     :constraint/unique-tenant-ignore-case
                                     {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                              :person/universal-email-address
                                                              [:entity.type/person])}}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "Person email"}}]

     [:person/work-email-address
      {:field/data-type             :data.type/text-simple
       :field/default-ord           33
       :field/default-visibility    {:editor :editor.type/text-simple
                                     :grid   :editor.type/text-simple
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/valid-email true}

       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "Work email address"}}]

     [:person/other-email-addresses
      {:field/data-type          :data.type/text-multiline
       :field/default-ord        36
       :field/default-visibility {:editor :editor.type/textarea
                                  :grid   :editor.type/textarea
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Other email addresses"}}]

     [:person/universal-phone-number
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Phone number"}}]

     [:person/mobile-phone-number
      {:field/data-type          :data.type/text-simple
       :field/default-ord        43
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Mobile phone number"}}]

     [:person/work-phone-number
      {:field/data-type          :data.type/text-simple
       :field/default-ord        46
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Work phone number"}}]

     [:person/notes
      {:field/data-type          :data.type/text-multiline
       :field/default-visibility {:editor :editor.type/textarea
                                  :grid   :editor.type/textarea
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Notes"}}]

     [:person/location-country
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Country"}}]
     [:person/location-state
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "State"}}]
     [:person/location-city
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "City"}}]
     [:person/location-zip-code
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Zip code"}}]

     [:person/location-address
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Address"}}]

     [:person/universal-title
      {:field/data-type          :data.type/text-simple
       :field/default-visibility {:editor :editor.type/text-simple
                                  :grid   :editor.type/text-simple
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Title"}}]

     [:person/gender
      {:field/data-type :data.type/keyword
       :value-type :keyword
       :field/not-importable? true
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/none
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/hidden-from-configuration? true
       :field/translations {:en "Gender"}
       :options gender/options}]

     [:person/avatar-url
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "Image"}
       :field/data-type             :data.type/text-url
       :field/not-importable?       true
       :field/hidden-from-configuration? true
       :field/default-visibility    {:editor           :editor.type/none
                                     :image            :editor.type/none
                                     :grid             :editor.type/none
                                     :filter           :filter.type/text
                                     :field-visibility :in-use-disabled}}]
     [:person/contact-owner
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/entity-types     [:entity.type/account]
       :field/translations     {:en "Contact owner"}
       :field/data-type        :data.type/ref-single
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type             :entity
       :field/option-filter-fn option-filters/active-users
       :field/os-filter-terms-fn    (fn [_args]
                                      {"extras.active-user" true})}]
     [:person/twitter
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Twitter"}
       :field/data-type          :data.type/text-url
       :field/default-visibility {:editor :editor.type/url
                                  :grid   :editor.type/url
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}}]
     [:person/crunchbase
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Crunchbase"}
       :field/data-type          :data.type/text-url
       :field/default-visibility {:editor :editor.type/url
                                  :grid   :editor.type/url
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}}]
     [:person/linkedin-url
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "LinkedIn"}
       :field/data-type          :data.type/text-url
       :field/default-visibility {:editor :editor.type/url
                                  :grid   :editor.type/url
                                  :filter :filter.type/text
                                  :field-visibility :in-use}}]

     [:person/facebook
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Facebook"}
       :field/data-type          :data.type/text-url
       :field/default-visibility {:editor :editor.type/url
                                  :grid   :editor.type/url
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}}]
     [:person/website
      {:field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations       {:en "Website"}
       :field/data-type          :data.type/text-url
       :field/default-visibility {:editor :editor.type/url
                                  :grid   :editor.type/url
                                  :filter :filter.type/text
                                  :field-visibility :not-in-use}}]
     [:person/tag-tags
      {:field/data-type          :data.type/ref-multi
       :value-type               :entity
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-tags
       :field/default-visibility {:editor :editor.type/multi-select
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/guest-buy-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-buy-side}
       :field/translations       {:en "Person tags"}}]
     [:person/tag-region-experience
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Region experience"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-region-experience
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-investment-preferences
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Investment preferences"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-investment-preferences
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use-blocked}
       :value-type               :entity}]
     [:person/tag-location
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Location"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-location
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-memberships
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Memberships"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-memberships
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-contact-priority
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Contact priority"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-contact-priority
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-university-alumni
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "University alumni"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-university-alumni
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-portfolio-alumni
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Portfolio alumni"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-portfolio-alumni
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-contact-status
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Contact status"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-contact-status
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-known-interests
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Known interests"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-known-interests
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-skill-categories
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Skill categories"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-skill-categories
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-certificates
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Certificates"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-certificates
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-vip-status
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "VIP status"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-vip-status
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-potential-board-roles
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Potential board roles"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-potential-board-roles
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-industry-experience
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Industry experience"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-industry-experience
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-seniority
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Seniority"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-seniority
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :not-in-use}
       :value-type               :entity}]
     [:person/tag-potential-executive-roles
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Potential executive roles"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-potential-executive-roles
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-sector-specialities
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Sector specialties"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-sector-specialities
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-language-skills
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Language skills"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-language-skills
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]
     [:person/tag-technology-skills
      {:field/default-authorization {:access/read   :role/guest-sell-side
                                     :access/create :role/admin
                                     :access/write  :role/guest-sell-side}
       :field/translations       {:en "Technology skills"}
       :field/data-type          :data.type/ref-multi
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :person/tag-technology-skills
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :value-type               :entity}]

     [:person/fullcontact-person
      {:field/data-type          :data.type/ref-single
       :field/constraints        {}
       :value-type               :entity
       :field/entity-types       [:entity.type/any]
       :field/serialization      :normal
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/none
                                  :filter :filter.type/none
                                  :field-visibility :in-use}
       :field/hidden-from-configuration? true
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/system-semantics   su/system-controlled-optional-field-semantics
       :field/translations       {:en "Intelligence data"}}]
     [:person/clearbit-person
      {:field/data-type          :data.type/ref-single
       :value-type               :entity
       :field/entity-types       [:entity.type/any]
       :field/serialization      :normal
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/none
                                  :filter :filter.type/none
                                  :field-visibility :in-use}
       :field/hidden-from-configuration? true
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/system-semantics   su/system-controlled-optional-field-semantics
       :field/translations       {:en "Clearbit intelligence data"}}]
     [:person/intelligence-person
      {:field/data-type          :data.type/ref-single
       :field/constraints        {}
       :field/entity-types       [:entity.type/any]
       :value-type               :entity
       :field/serialization      :normal
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/none
                                  :filter :filter.type/none
                                  :field-visibility :in-use}
       :field/hidden-from-configuration? true
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/system-semantics   su/system-controlled-optional-field-semantics
       :field/translations       {:en "Intelligence data"}}]
     [:person/email-opt-in
      {:field/data-type             :data.type/boolean
       :field/not-clearable?        true
       :field/default-visibility    {:editor :editor.type/toggle
                                     :grid   :editor.type/toggle
                                     :filter :filter.type/boolean
                                     :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Email opt-in"}}]
     [:person/opt-out-marketing-emails
      {:field/data-type             :data.type/boolean
       :field/not-clearable?        true
       :field/default-visibility    {:editor :editor.type/toggle
                                     :grid   :editor.type/toggle
                                     :filter :filter.type/boolean
                                     :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "No marketing emails"}}]]
    (su/datetime-field :person/datetime-last-meeting-date
                       "Last meeting date"
                       {:default-field-visibility :not-in-use})
    (su/text-multiline-field :person/contact-comments
                             "Contact comments"
                             {:default-field-visibility :not-in-use})
    (su/text-multiline-field :person/next-steps
                             "Next steps"
                             {:default-field-visibility :not-in-use})
    (su/option-field :person/prefix "Prefix" {:default-field-visibility :not-in-use})
    (su/option-field :person/suffix "Suffix" {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/middle-name "Middle name" {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/nickname "Nickname" {:default-field-visibility :not-in-use})
    (su/email-field :person/secondary-email-address
                    "Secondary email address"
                    {:default-field-visibility :not-in-use})
    (su/email-field :person/tertiary-email-address
                    "Tertiary email address"
                    {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/degree "Degree" {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/source-details
                          "Source details"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/fax-number "Fax number" {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/tag-mailing-lists
                           "Mailing lists"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/tag-contact-type
                           "Type of contact"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/tag-cohort "Cohort" {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/tag-contact-source
                           "Contact source"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/professional-designations
                           "Professional designations"
                           {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/undergrad-institution
                          "Undergrad institution"
                          {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/undergrad-degree
                           "Undergrad degree"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/undergrad-focus
                           "Undergrad focus"
                           {:default-field-visibility :not-in-use})
    (su/integer-field :person/undergrad-year
                      "Undergrad year"
                      {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/graduate-school
                          "Graduate school"
                          {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/graduate-degree
                           "Graduate degree"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/graduate-focus
                           "Graduate focus"
                           {:default-field-visibility :not-in-use})
    (su/integer-field :person/graduate-year "Graduate year" {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/doctoral-institution
                          "Doctoral institution"
                          {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/doctoral-degree
                           "Doctoral degree"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/doctoral-focus
                           "Doctoral focus"
                           {:default-field-visibility :not-in-use})
    (su/integer-field :person/doctoral-year "Doctoral year" {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/post-doctoral-institution
                          "Post-doctoral institution"
                          {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/post-doctoral-focus
                           "Post-doctoral focus"
                           {:default-field-visibility :not-in-use})
    (su/integer-field :person/post-doctoral-year
                      "Post-doctoral year"
                      {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/type-of-contact
                           "Type of contact"
                           {:default-field-visibility :not-in-use})
    (su/option-field :person/cohort "Cohort" {:default-field-visibility :not-in-use})
    (su/option-field :person/contact-priority
                     "Contact priority"
                     {:default-field-visibility :not-in-use})
    (su/option-field :person/contact-status
                     "Contact status"
                     {:default-field-visibility :not-in-use})
    (su/option-field :person/accreditation "Accreditation" {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/investor-type
                           "Investor type"
                           {:default-field-visibility :not-in-use})
    (su/option-field :person/investing-experience
                     "Investing experience"
                     {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/contact-source
                           "Contact source"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :person/referred-by
                           "Referred by"
                           {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/work-street-address
                          "Work street address"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/work-address-city
                          "Work address city"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/work-address-state
                          "Work address state"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/work-address-country
                          "Work address country"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/work-address-zip-code
                          "Work address zip code"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-street-address
                          "Home street address"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-address-city
                          "Home address city"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-address-state
                          "Home address state"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-address-country
                          "Home address country"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-address-zip-code
                          "Home address zip code"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/other-street-address
                          "Other street address"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/other-address-city
                          "Other address city"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/other-address-state
                          "Other address state"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/other-address-country
                          "Other address country"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/other-address-zip-code
                          "Other address zip code"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/initials "Initials" {:default-field-visibility :not-in-use})
    (su/option-field :person/investment-size
                     "Typical Investment Size"
                     {:default-field-visibility :not-in-use-blocked})
    (su/option-field :person/investment-stage
                     "Investment Stage"
                     {:default-field-visibility :not-in-use-blocked})
    (su/date-field :person/birth-date "Birth date" {:default-field-visibility :not-in-use})
    (su/keyword-field :person/country-code
                      "Country"
                      country/options
                      {:default-field-visibility :not-in-use
                       :authorization su/access-user-ssg})
    (su/option-field-multi :person/tag-portfolio-company
                           "Portfolio company"
                           {:default-field-visibility :not-in-use
                            :authorization su/access-user-ssg})
    (su/single-ref-field :person/current-employer
                         "Current employer"
                         [:entity.type/company]
                         {:default-field-visibility :not-in-use
                          :authorization su/access-user-ssg})

    (su/option-field :person/department
                     "Department"
                     {:default-field-visibility :not-in-use-blocked})
    (su/text-simple-field :person/assistants-name
                          "Assistant's Name"
                          {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/account-name
                          "Account Name"
                          {:default-field-visibility :not-in-use})
    (su/option-field :person/geographic-responsibility
                     "Geographic Responsibility"
                     {:default-field-visibility :not-in-use})
    ;(su/option-field :person/primary-contact-person "Primary Contact Person" {:default-field-visibility :not-in-use})
    ;(su/option-field :person/secondary-contact-person "Secondary Contact Person" {:default-field-visibility :not-in-use})
    (su/date-field :person/last-contact-date
                   "Last Contact Date"
                   {:default-field-visibility :not-in-use})
    (su/text-simple-field :person/home-phone-number
                          "Home Phone Number"
                          {:default-field-visibility :not-in-use})

    (su/multi-ref-field :person/risk-entities
                        "Risks"
                        [:entity.type/risk-holding]
                        {:authorization    su/access-user-user
                         :editor-type      :editor.type/none
                         :grid-type        :editor.type/none
                         :filter-type      :filter.type/boolean
                         :required-modules [:module/risk-module]})

    ;; leave this for easier merging
    )))
